import { initSentry } from './sentry';
initSentry();  // ADD as first call before anything else
// Buffers recent console errors for the onboarding feedback bubble (memory only, opt-in send)
import './utils/clientDiagnostics';
import { railwayRedirectTarget } from './utils/railwayRedirect';

if (typeof window !== 'undefined' && window.location) {
  const redirectUrl = railwayRedirectTarget(window.location);
  if (redirectUrl) {
    window.location.replace(redirectUrl);
  }
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { AuthProvider } from './contexts/AuthContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';
// i18n MUST be imported before App renders — this runs init() synchronously
import './i18n/index';
import App from './App';
import { QueryClient, QueryClientProvider } from 'react-query';

// Initialize QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <AuthProvider>
              <CurrencyProvider>
                <QueryClientProvider client={queryClient}>
                  <App />
                </QueryClientProvider>
              </CurrencyProvider>
            </AuthProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// SW listener removed, handled cleanly by vite-plugin-pwa and ServiceWorkerUpdate.jsx component
